export const LOADS_API_URL = process.env.REACT_APP_LOADS_API_URL;
export const LOGGER_CONFIG = process.env.REACT_APP_LOGGER_CONFIG;
export const { NODE_ENV } = process.env;
export const PAGE_SIZE = process.env.REACT_APP_PAGE_SIZE;
export const OIDC_CLIENT_ID = process.env.REACT_APP_OIDC_CLIENT_ID;
export const OIDC_AUTHORITY = process.env.REACT_APP_OIDC_AUTHORITY;
export const GOOGLE_PLACES_API_URL = process.env.REACT_APP_GOOGLE_PLACES_AUTOCOMPLETE_URL;
export const GOOGLE_PLACE_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_AUTOCOMPLETE_KEY;
export const INACTIVITY_WARNING_TIME = process.env.REACT_APP_INACTIVITY_WARNING_TIME;
export const INACTIVITY_LOGOUT_TIME = process.env.REACT_APP_INACTIVITY_LOGOUT_TIME;
export const TMS_APP_URL = process.env.REACT_APP_TMS_URL;
export const APPINSIGHTS_INSTRUMENTATIONKEY = process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY;
export const CLIENT_APP_URL = process.env.REACT_APP_CLIENT_URL || 'https://gtz-wus-tnt-dv.azurewebsites.net/'; // add to backend for automated emails too
export const LTL_FEATURE_FLAG = process.env.REACT_APP_LTL_FEATURE_FLAG;
export const AG_GRID_LICENSE_KEY = process.env.REACT_APP_AG_GRID_LICENSE_KEY;
